export default "__VITE_ASSET__C7SUhtB6__"